import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { JsonFileError } from "./web-api.models";
import { map, catchError } from "rxjs/operators";
import { Observable ,  Subject ,  throwError as _throw } from "rxjs";

@Injectable()
export class JsonFileService {
	private errorSubject = new Subject<JsonFileError>();
	public jsonFileError = this.errorSubject.asObservable();

	constructor(private http: HttpClient) {}

	public get<T>(jsonFileUrl: string): Observable<T> {
		return this.getRemoteJsonFile<T>(jsonFileUrl);
	}

	private getRemoteJsonFile<T>(jsonFileUrl: string): Observable<T> {
		return this.http.get<T>(jsonFileUrl).pipe(
			map(result => <T>result),
			catchError(error => this.errorResponseHandler(error, jsonFileUrl))
		);
	}

	private errorResponseHandler(
		error: HttpErrorResponse,
		jsonFileUrl: string
	): Observable<never> {
		const jsonFileError: JsonFileError = <JsonFileError>{};
		jsonFileError.fileUrl = jsonFileUrl;
		jsonFileError.error = error;
		return _throw(jsonFileError);
	}
}
